import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import { AddButton, Loader, NoItemsYet } from 'components';
import { AccessManagement, AddRoleModal } from './core';
import { FindLoad, FindSuccessItem, Images, PermissionList, RolePermission, useModal } from 'utils';
import { httpRequestsOnSuccessActions, permissionsActions, roleActions } from 'store';

const CREATE_ACTION = 'CREATE_ROLE';
const GET_ROLE = 'GET_ROLE';

export const Management = ({}) => {
    const { permissionsList, rolesList, role } = useSelector((state) => ({
        permissionsList: state.permissions.permissionsList,
        rolesList: state.roles.rolesList,
        role: state.roles.role,
    }));
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const createSuccess = FindSuccessItem('CREATE_ROLE');
    const { open } = useModal();
    const { roles, count } = rolesList || {};
    const loader = FindLoad(GET_ROLE);

    useEffect(() => {
        dispatch(roleActions.removeRole());
        dispatch(permissionsActions.getPermissions());
    }, []);

    const getRoles = (load) => {
        const infoItem = {};
        infoItem.skip = info?.skip ? info?.skip : 0;
        infoItem.limit = 50;
        info?.sortType ? (infoItem.sortType = info.sortType) : '';
        dispatch(roleActions.getRole({ ...infoItem }, load));
    };

    useEffect(() => {
        getRoles();
    }, [info]);

    useEffect(() => {
        if (createSuccess) {
            getRoles('noLoad');
            dispatch(httpRequestsOnSuccessActions.removeSuccess(CREATE_ACTION));
        }
    }, [createSuccess]);

    if (loader?.length) {
        return <Loader />;
    }

    return (
        <div>
            {rolesList?.count > 0 ? (
                <AccessManagement
                    afterSuccess={() => getRoles('noLoad')}
                    info={info}
                    rolesList={roles}
                    permissionsList={permissionsList}
                    role={role}
                    rolesCount={count}
                />
            ) : (
                <div style={{ position: 'relative' }}>
                    <NoItemsYet
                        text={'No Roles or permissions yet'}
                        subTitle={"You haven't added any roles or permissions yet. Click the button below to get started."}
                        image={Images.noFsYet}
                    />
                </div>
            )}
        </div>
    );
};
